import React from 'react';
import { connect } from 'react-redux';
import { NotificationsContainer, _connect } from './NotificationsContainer';
import Notification from './RPC_Notification';

class RPC_NotificationsContainer extends NotificationsContainer {

    constructor(props) {
        super(props);
    }

    _renderFlags() {
        const { _notifications, _className } = this.props;

        return _notifications.map(notification => {
            const { props, uid } = notification;

            // The id attribute is necessary as {@code FlagGroup} looks for
            // either id or key to set a key on notifications, but accessing
            // props.key will cause React to print an error.
            return (
                <div className = { _className } key={ '_'+uid }>
                <Notification
                    { ...props }
                    id = { uid }
                    key = { uid }
                    onDismissed = { this._onDismissed }
                    uid = { uid } />

                </div>
            );
        });
    }
}

function _mapStateToProps(state) {

    const toolBoxVisible = state['features/toolbox'].visible;
    const { isOpen: isChatOpen } = state['features/chat'];
    const { isOpen: isParticipantsPaneOpen } = state['features/participants-pane'];
    const _className = (!toolBoxVisible || isChatOpen || isParticipantsPaneOpen) ? ' bottom ' + ( (isChatOpen || isParticipantsPaneOpen) ? ' right-padded ' : '') : '';
    
    return {
        _className
    };
}

export default _connect(connect(_mapStateToProps)(RPC_NotificationsContainer))